import React, { useEffect, useState } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";

import { useProfile } from "../Common/Hooks/UserHooks";

import { logoutUser } from "../slices/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  // const { userProfile, loading, token } = useProfile();
  // useEffect(() => {
  //   if (userProfile && !loading && token) {
  //     setAuthorization(token);
  //   } else if (!userProfile && loading && !token) {
  //     dispatch(logoutUser());
  //   }
  // }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */
  const [mount, setMount] = useState(false);

  useEffect(() => { setMount(true) }, [mount])
  const { token, user } = useSelector(state => state?.Auth)
  const authToken = token || localStorage.getItem('knighthuntToken');
  const userData = JSON.parse(localStorage.getItem('knighthuntUserInfo'));
  const userId = user?.id || userData?.id
  if (!userId && !authToken && mount) {
    return (
      <Navigate to={{ pathname: "/login" }} />
    );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
